export default __webpack_public_path__ + "static/media/kinder5.6ec8d792.jpg";